import Vue from 'vue'
import VuePagination from 'vuejs-paginate'
import { Carousel, Slide } from 'vue-carousel'
import Vue2TouchEvents from 'vue2-touch-events'
import VueGtag from "vue-gtag";
import PortalVue from 'portal-vue'
import VueTheMask from 'vue-the-mask'
import { VTooltip } from 'v-tooltip'

export default ({ $config }) => {
    Vue.component('pagination', VuePagination)
    Vue.component('vue-carousel', Carousel);
    Vue.component('vue-slide', Slide);

    Vue.use(Vue2TouchEvents)
    Vue.use(PortalVue)
    Vue.use(VueTheMask)

    Vue.directive('tooltip-html', VTooltip)

    Vue.use(VueGtag, {
        config: {
            id: 'G-EGTQM5P5GJ',
            params: {
                send_page_view: true
            }
        }
    });
}

